export const femaleNames = [
  'Grace', 'Claire', 'Nora', 'Elise', 'Maren',
  'Sage', 'Ada', 'Ruth', 'Naomi', 'Lydia'
];

export const maleNames = [
  'Caleb', 'Eli', 'Owen', 'Samuel', 'James',
  'Nathan', 'Micah', 'Joel', 'Levi', 'Aaron'
];

export function getRandomName(gender) {
  const pool = gender === 'female' ? femaleNames : maleNames;
  return pool[Math.floor(Math.random() * pool.length)];
}
